import { findBrandByDomain } from "../configs/configLoader";

const brandDefined = findBrandByDomain();

const isGivenchy = brandDefined?.name === "Givenchy";
const isDevernois = brandDefined?.name === "Devernois";

const urlParameters = new URLSearchParams(window.location.search);

const forcedError = urlParameters.get("error") === "true";

export const MOCK_ADULT_RECOMMENDATION = [
  {
    label: "XS",
    variant_id: "45493387067650",
    possible: 1,
    label_rank: 0,
    fit_indicators: [
      {
        limb: "hip",
        value: 3,
      },
    ],
  },
  {
    label: "S",
    variant_id: "45493387100418",
    possible: forcedError ? 0 : 1,
    label_rank: 1,
    fit_indicators: [
      {
        limb: "hip",
        value: 2,
      },
    ],
  },
  {
    label: "M",
    variant_id: "45493387133186",
    possible: 0,
    label_rank: 2,
    fit_indicators: [
      {
        limb: "hip",
        value: 5,
      },
    ],
  },
];

export const MOCK_ADULT_STOCKS_DATA = [
  {
    variant_reference: "45493387034882",
    quantity: 0,
  },
  {
    variant_reference: "45493387067650",
    quantity: isGivenchy || isDevernois ? 0 : 10,
  },
  {
    variant_reference: "45493387100418",
    quantity: 10,
  },
  {
    variant_reference: "45493387133186",
    quantity: 10,
  },
  {
    variant_reference: "45493387165954",
    quantity: 0,
  },
];

export const MOCK_FOOTWEAR_RECOMMENDATION = {
  good: {
    label: "40",
    variant_id: "45493387067651",
    possible: 1,
    label_rank: 0,
    fit_indicators: [
      {
        limb: "hip",
        value: 3,
      },
    ],
  },
  bigger: {
    label: "41",
    variant_id: "45493387067652",
    possible: 1,
    label_rank: 1,
    fit_indicators: [
      {
        limb: "hip",
        value: 2,
      },
    ],
  },
  smaller: {
    label: "39",
    variant_id: "45493387067653",
    possible: 0,
    label_rank: 2,
    fit_indicators: [
      {
        limb: "hip",
        value: 5,
      },
    ],
  },
};

export const MOCK_FOOTWEAR_STOCKS_DATA = [
  {
    variant_reference: "45493387067651",
    quantity: 10,
  },
  {
    variant_reference: "45493387067652",
    quantity: 10,
  },
  {
    variant_reference: "45493387067653",
    quantity: 10,
  },
];

export const MOCK_SIMILAR_PRODUCTS_Devernois = [
  {
    title: "Blouse fluide CROQUET/12076/006",
    retailer_product_reference: "15003924726137",
    brand: "devernois",
    image_url:
      "https://cdn.shopify.com/s/files/1/0710/9941/6864/files/CROQUET-12076-006_A.jpg?v=1748425713",
    product_url:
      "https://www.devernois.com/products/blouse-fluide-croquet-12076-006",
    price: {
      current: "94.5",
      currency: "EUR",
      compareAt: "189.0",
    },
  },
  {
    title: "Chemise fluide COCON/12073/003",
    retailer_product_reference: "15003924824441",
    brand: "devernois",
    image_url:
      "https://cdn.shopify.com/s/files/1/0710/9941/6864/files/COCON-12073-003_A_cb9d86a7-7f1d-4d6b-af03-6483d465b637.jpg?v=1750259001",
    product_url:
      "https://www.devernois.com/products/chemise-fluide-cocon-12073-003",
    price: {
      current: "113.4",
      currency: "EUR",
      compareAt: "189.0",
    },
  },
  {
    title: "Chemisier fluide CHANTILLY/12119/635",
    retailer_product_reference: "15043682697593",
    brand: "devernois",
    image_url:
      "https://cdn.shopify.com/s/files/1/0710/9941/6864/files/CHANTILLY-12119-635_A.jpg?v=1751983756",
    product_url:
      "https://www.devernois.com/products/chemisier-fluide-chantilly-12119-635",
    price: {
      current: "132.3",
      currency: "EUR",
      compareAt: "189.0",
    },
  },
  {
    title: "Chemise brodée COCO/88151/003",
    retailer_product_reference: "9186895364436",
    brand: "devernois",
    image_url:
      "https://cdn.shopify.com/s/files/1/0710/9941/6864/files/NOEL_COCO-88151-003_F.jpg?v=1731657400",
    product_url:
      "https://www.devernois.com/products/chemise-brodee-coco-88151-003",
    price: {
      current: "94.5",
      currency: "EUR",
      compareAt: "189.0",
    },
  },
  {
    title: "Blouse détails brodés CLARENCE/82184/009",
    retailer_product_reference: "8404356432212",
    brand: "devernois",
    image_url:
      "https://cdn.shopify.com/s/files/1/0710/9941/6864/products/CLARENCE-82184-009_A.jpg?v=1685633792",
    product_url:
      "https://www.devernois.com/products/blouse-details-brodes-clarence-82184-9",
    price: {
      current: "69.5",
      currency: "EUR",
      compareAt: "139.0",
    },
  },
  {
    title: "Blouse à encolure volantée COLOMBAGE/11187/003",
    retailer_product_reference: "9927731937620",
    brand: "devernois",
    image_url:
      "https://cdn.shopify.com/s/files/1/0710/9941/6864/files/COLOMBAGE-11187-COL003-FRONT_474eb409-3c1c-4736-8fe2-00a37e0cc0a8.jpg?v=1736433773",
    product_url:
      "https://www.devernois.com/products/blouse-a-encolure-volantee-colombage-11187-003",
    price: {
      current: "189.0",
      currency: "EUR",
      compareAt: "0.0",
    },
  },
];

export const MOCK_SIMILAR_PRODUCTS = [
  {
    title: "Robe du soir bustier drapée en satin avec nœud",
    retailer_product_reference: "TEST",
    brand: "givenchy",
    image_url:
      "https://assets.givenchy.com/asset/67d38d66-67f0-4536-b9a6-188177582ae6/High-Resolution-JPG/BW22KW1YG0001-02-01.jpg?imwidth=1500",
    product_url:
      "https://www.givenchy.com/fr/fr/robe-du-soir-bustier-drapee-en-satin-avec-noeud/BW22KW1YG0-001.html",
    price: {
      current: "30000.0",
      currency: "EUR",
      compareAt: "0.0",
    },
  },
  {
    title: "Robe dos nu à volants en maille",
    retailer_product_reference: "TEST",
    brand: "givenchy",
    image_url:
      "https://assets.givenchy.com/asset/dc163517-8ad2-4eb0-b266-4fbade942308/High-Resolution-JPG/BW22L44ZSK001-02-02.jpg?imwidth=1500",
    product_url:
      "https://www.givenchy.com/fr/fr/robe-dos-nu-a-volants-en-maille/BW22L44ZSK-001.html",
    price: {
      current: "3900.0",
      currency: "EUR",
      compareAt: "0.0",
    },
  },
  {
    title: "TRENCH PRADEL BEIGE",
    retailer_product_reference: "15273975185782",
    brand: "givenchy",
    image_url:
      "https://cdn.shopify.com/s/files/1/0352/8464/8076/files/LOOK_04_FIRA_GILL_THEA_PRADEL_001_3b7a69c5-ceb1-4dc3-b8be-8e9a61f90cec.jpg?v=1758008609",
    product_url:
      "https://www.soeur.fr/products/trench-pradel-mastic-man1331pradel23wecr34",
    price: {
      current: "375.0",
      currency: "EUR",
      compareAt: "0.0",
    },
  },
  {
    title: "Robe drapée en crêpe cady",
    retailer_product_reference: "TEST",
    brand: "givenchy",
    image_url:
      "https://assets.givenchy.com/asset/7532a635-767e-4e88-a2e9-ae45171c5999/High-Resolution-JPG/BW22MV164K001-02-01.jpg?imwidth=1500",
    product_url:
      "https://www.givenchy.com/fr/fr/robe-drapee-en-crepe-cady/BW22MV164K-001.html",
    price: {
      current: "1900.0",
      currency: "EUR",
      compareAt: "0.0",
    },
  },
  {
    title: "Robe décolletée en laine",
    retailer_product_reference: "TEST",
    brand: "givenchy",
    image_url:
      "https://assets.givenchy.com/asset/05fd76a2-3a90-476b-b58c-fd165efbf9db/High-Resolution-JPG/BW22M2167R001-02-02.jpg?imwidth=1500",
    product_url:
      "https://www.givenchy.com/fr/fr/robe-decolletee-en-laine/BW22M2167R-001.html",
    price: {
      current: "2800.0",
      currency: "EUR",
      compareAt: "0.0",
    },
  },
];

export const SMALL_PADDING_BRANDS = [
  "Lacoste",
  "KENZO",
  "Sporty & Rich",
  "Le Slip Français",
  "IZAC",
  "From Future",
  "Molli",
  "Place du Jour",
  "Gualap",
  "Vogstore",
  "Loulou de Saison",
];

export const MEDIUM_PADDING_BRANDS = [
  "JOTT",
  "Circle SportsWear",
  "Chlore",
  "SRP",
  "Hartford",
  "La Petite Etoile",
  "Mister K",
  "Petrone",
  "Bensimon",
  "Stella & Suzie",
  "Antonelle",
  "Kookai",
  "Une Jour Ailleurs",
  "Asphalte",
  "Place des Tendances",
  "Rodier",
  "La Canadienne",
  "Gerard Darel",
  "Ron Dorff",
  "The Kooples",
  "Nina Ricci",
  "Sport 2000",
  "Victoria Beckham",
  "Loro Piana",
  "Rabanne",
  "Weill",
  "Sud Express",
  "Loom",
  "Alme",
  "Ogier",
  "Eric Bompard",
  "Intersport",
  "Blackstore",
  "Culto",
  "Pyrenex",
  "Club Brugge",
  "Givenchy",
  "Celio",
];
